import { Injectable, InjectionToken } from '@angular/core';
import { AnyQuerySuggestions, CustomSearchResults } from '@search/const';
import { Converter } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class SuggestionsAnyQueryNormalizer implements Converter<AnyQuerySuggestions, CustomSearchResults> {
  convert(source: AnyQuerySuggestions, target: CustomSearchResults): CustomSearchResults {
    if (!target) {
      target = { ...source } as any;
    }

    try {
      target.categories = source.categories.map((category) => ({
        ...category,
        code: category.id,
        url: category.link_url,
      }));
    } catch {}

    return target;
  }
}

export const SUGGESTIONS_ANY_QUERY_NORMALIZER = new InjectionToken<SuggestionsAnyQueryNormalizer>(
  'SuggestionsAnyQueryNormalizer',
);
